import React, { useState } from 'react'
import { FaTimes } from 'react-icons/fa'
import { MwInputFile } from '../ui'
import { deleteUploadedFiles, getAttachmentInfo, uploadSupportFiles } from '../../utils/attachments'

// رفع المرفقات بنفس طريقة التذاكر. `value` قائمة الروابط، و `onBusyChange` عشان نقفل الحفظ أثناء الرفع.
// `names` = { [url]: الاسم الأصلي }، و `onNamesChange` بيستقبل أسماء الملفات الجديدة.
const ProjectAttachmentsField = ({ value = [], names = {}, onChange, onNamesChange, onBusyChange, lang = 'ar', id = 'support_project_attachment' }) => {
    const [uploading, setUploading] = useState(false);
    const [removing, setRemoving] = useState(false);
    const [error, setError] = useState(null);
    const isAr = lang === 'ar';
    const failedMsg = isAr ? 'فشل رفع الملف، حاول مرة أخرى' : 'Upload failed, please try again';

    const setBusy = (setter, busy) => {
        setter(busy);
        onBusyChange?.(busy);
    };

    const uploadHandler = async (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        setError(null);
        setBusy(setUploading, true);
        try {
            const uploaded = await uploadSupportFiles(files);
            onNamesChange?.(Object.fromEntries(uploaded.map((item) => [item.url, item.name])));
            onChange?.(Array.from(new Set([...(value || []), ...uploaded.map((item) => item.url)])));
            e.target.value = '';
        } catch {
            setError(failedMsg);
        } finally {
            setBusy(setUploading, false);
        }
    };

    const removeHandler = async (url) => {
        setBusy(setRemoving, true);
        try {
            if (await deleteUploadedFiles([url])) {
                onChange?.((value || []).filter((item) => item !== url));
                setError(null);
            } else {
                setError(failedMsg);
            }
        } catch {
            setError(failedMsg);
        } finally {
            setBusy(setRemoving, false);
        }
    };

    return (
        <div className="flex flex-col gap-2">
            <MwInputFile
                label={isAr ? 'المرفقات' : 'Attachments'}
                onChangeHandler={uploadHandler}
                acceptTypes="*/*"
                loading={uploading}
                disabled={uploading || removing}
                id={id}
                multiple
            />
            {(value || []).map((url) => (
                <div key={url} className="flex items-center justify-between gap-3 px-2">
                    <a href={url} target="_blank" rel="noreferrer" className="text-xs font-semibold text-slate-600 hover:text-[#08203f] truncate">
                        {getAttachmentInfo(url, names).name}
                    </a>
                    <button
                        type="button"
                        onClick={() => removeHandler(url)}
                        disabled={uploading || removing}
                        className="p-1 hover:bg-red-50 rounded-full text-red-500 hover:text-red-700 transition-colors disabled:opacity-50"
                    >
                        <FaTimes size={14} />
                    </button>
                </div>
            ))}
            {error && <p className="text-xs text-red-500 px-2">{error}</p>}
        </div>
    );
};

export default ProjectAttachmentsField;
